import React from 'react';

import styled from 'styled-components';

import { InlineLink, Text, colors, spacing } from '@sine/sine-ui-components';

const Container = styled.div`
  width: 100%;
  margin-bottom: ${spacing(3)};
`;

const StyledInlineLink = styled(InlineLink)`
  color: ${colors.grey1300};
  :active {
    color: ${colors.grey1300};
  }
`;

export interface Crumb {
  label: string;
  onClick?: () => void;
}

export interface BreadCrumbsProps {
  className?: string;
  crumbs: Array<Crumb>;
}

export function BreadCrumbs({ className, crumbs }: BreadCrumbsProps) {
  const formatted = crumbs.reduce<BreadCrumbsProps['crumbs']>((list, crumb, i) => {
    if (i !== 0) {
      list.push({ label: ' / ' });
    }

    list.push(crumb);

    return list;
  }, []);

  return (
    <Container className={className}>
      {formatted.map(({ label, onClick }, index) =>
        onClick ? (
          <StyledInlineLink key={label} onClick={onClick}>
            {label}
          </StyledInlineLink>
        ) : (
          <Text key={index}>{label}</Text>
        ),
      )}
    </Container>
  );
}
